export const typeSceneEnum = {
  static: 'STATIC',
  playground: 'PLAYGROUND',
  both: 'BOTH'
};
